// 导入axios实例
import httpRequest from "@/request/index"
import base from "@/request/base"
import qs from "qs"
import { platformStore } from "@/store/index"
const devUrl = "https://tpay.qingcigame.com" //开发环境使用

/**
 * 获取平台store实例
 * @returns {Object} platformStore实例
 */
function getStore() {
  return platformStore()
}
// 获取游戏列表
export function getGameList(params) {
  return httpRequest({
    url: `${base.url2}/v1/pay/official/list${qs.stringify(params)}`,
    method: "get",
    headers: {
      "X-Origin": process.env.NODE_ENV === "production" ? "" : devUrl, //开发环境使用测试环境，生产环境为空
    },
  })
}
// 我的订单页面列表获取
export function order(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/order?${qs.stringify(params)}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
      "X-Origin": process.env.NODE_ENV === "production" ? "" : devUrl, //开发环境使用测试环境，生产环境为空
    },
  })
}
// 生成支付web单
export function webPay(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v3/pay/web`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 微信支付校验接口（微信授权）
export function wechatPayCashier(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v3/pay/web/cashier/${params.cashier}?open_id=${params.open_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
//微信授权
export function wechatAuthorization() {
  return httpRequest({
    url: `${base.wechat}/wechat/info`,
    method: "get",
    withCredentials: true,
  })
}
// 微信jssdk
export function settingShare(params) {
  return httpRequest({
    url: `${base.wechat}/wechat/jssdk`,
    method: "post",
    data: qs.stringify(params),
    headers: {},
  })
}
//获取玩家补款信息
export function compensate(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v3/pay/compensate/?game_id=${params.gameId}&token=${params.token}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 补款支付调取
export function compensatePay(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v3/pay/compensate`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取总的积分
export function getPoints() {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/user/total`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    showLoading: false,
  })
}
// 获取商品列表
export function getProductList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/product?game_id=${params.game_id}&officialSettingId=${params.officialSettingId}&limit=100&type=${params.type}&role_id=${params.role_id}`,
    method: "get",
    headers: {
      Authorization: store.access_token ? `Bearer ${store.access_token}` : "",
    },
  })
}
// 积分商城商品兑换
export function pointsExchange(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/submit`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 周边兑换码兑换
export function exchangePeripheralCode(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/cdkey/submit`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    hideErrorToast: true,
  })
}
// 校验积分剩余库存
export function checkProduct(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/stock`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
//删除用户地址
export function delAddress(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/user_address/${params.id}`,
    method: "delete",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取用户地址
export function getAddressList() {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/user_address`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 修改用户地址
export function modifyAddress(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/user_address/${params.id}`,
    method: "put",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 实名认证
export function updateUser(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/web/account`,
    method: "put",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 用户添加地址
export function addAddressApi(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/user_address`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取兑换记录跟积分明细,我的仓库信息获取
export function getRecordList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/user?type=${params.type}&game_id=${params.game_id}&half=${params.half}&page=${params.page}&limit=${params.limit}&status=${params.status}&ware_status=${params.ware_status || ""}&id=${params.id}&official_setting_id=${params.official_setting_id}&activity_id=${params.activity_id ? params.activity_id : ''}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 代付订单提交
export function payForOther(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/behalf`,
    method: "post",
    data: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
      "Content-Type": "application/json",
    },
  })
}
// 获取代付订单数据
export function getPayForOtherList(params) {
  return httpRequest({
    url: `${base.url2}/v1/pay/official/behalf/detail?trade_no=${params.trade_no}`,
    method: "get",
  })
}
// 购物车记录上传
export function addShoppingCart(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/cart`,
    method: "post",
    data: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
      "Content-Type": "application/json",
    },
  })
}
// 最近角色保存
export function saveRecentRole(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/roles/save`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 免费礼包领取
export function freeGift(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/pack`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 悬浮窗奖励领取
export function reward(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/suspension`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取抽奖列表
export function getLotteryList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery?limit=10&page=1&game_id=${params.game_id}&type=${params.type}&role_id=${params.role_id}&official_setting_id=${params.official_setting_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    hideErrorToast: !params.role_id,
    showLoading: !params.hideLoading,
  })
}
// 抽奖地址确认
export function lotteryConfirm(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/address/${params.id}`,
    method: "put",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// pwa分享弹窗状态变化
export function shareStatus(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/popup/save`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 刷新上新信息
export function refreshNewProductList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/product`,
    method: "put",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 抽奖活动通用接口
export function pointsLottery(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/submit`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取积分中奖记录
export function getPointsLotteryLog(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/points/user?limit=10&lottery=1&page=${params.page}&lottery_id=${params.lottery_id}&role_id=${params.role_id}&official_setting_id=${params.official_setting_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 活动抽奖奖励列表
export function getActivityLotteryAwardList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/list?limit=100&id=${params.id}&role_id=${params.role_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 活动抽奖任务列表
export function getActivityLotteryTaskList(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/task?limit=10&id=${params.id}&role_id=${params.role_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 活动抽奖登录任务
export function activityLotteryLoginTask(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/task_login`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 获取仓库是否有新入库商品
export function getWarehouseNewProduct() {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/ware`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    showLoading: false,
  })
}
// 确认仓库入库商品
export function confirmWarehouseNewProduct() {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lottery/ware`,
    method: "delete",
    data: qs.stringify(),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 维护状态获取
export function getMaintainStatus(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/close?game_id=${params.game_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    showLoading: false,
  })
}
/**
 * 获取多语言的配置信息
 * @returns {Promise<Object>} 语言配置响应，包含companyId等信息
 */
export function getLangConfig() {
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lang/list`,
    method: "get",
    headers: {
      "X-Origin": process.env.NODE_ENV === "production" ? "" : devUrl, //开发环境使用测试环境，生产环境为空
    },
  })
}
/**
 * 多语言包主体信息获取
 * @returns {Promise<Object>} 公司主体信息响应
 */
export function getLangConfigMain() {
  const store = getStore()
  const companyId = store.companyId
  return httpRequest({
    url: `${base.url2}/v1/pay/official/company/${companyId || ""}`,
    method: "get",
    headers: {
      "X-Origin": process.env.NODE_ENV === "production" ? "" : devUrl, //开发环境使用测试环境，生产环境为空
    },
  })
}
/**
 * 获取多语言包
 * @returns {Promise<Object>} 语言包响应
 */
export function getLangPack() {
  const store = getStore()
  const companyId = store.companyId
  return httpRequest({
    url: `${base.url2}/v1/pay/official/lang/show?company_id=${companyId || ""}`,
    method: "get",
  })
}
// 新版充值列表接口
export function getNewRechargeList(game, role, server_id, officialSettingId) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/show/${game}?role_id=${role || ""
      }&server_id=${server_id || ""}&officialSettingId=${officialSettingId}`,
    method: "get",

    headers: {
      Authorization: store.access_token ? `Bearer ${store.access_token}` : "",
    },
  })
}
// 每日奖励领取
export function getDailyReward(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/daily`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
//获取预定单号
export function getPreOrder(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/order/submit`,
    method: "post",
    data: JSON.stringify(params), // 改为 JSON 序列化
    headers: {
      Authorization: `Bearer ${store.access_token}`,
      "Content-Type": "application/json",
    },
  })
}
// 游戏开启状态查询
export function getGameOpenStatus(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/game_list?game_id=${params.gameId}&officialSettingId=${params.officialSettingId}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 每日签到奖励获取
export function rewardDaily(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/daily`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
//获取游戏内跳转商品类型接口
export function getInGameProductType(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/product?game_id=${params.game_id}&official_setting_id=${params.official_setting_id}&sku_id=${params.sku_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 充值订单状态查询
export function getOrderStatus(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/order/info?trade_no=${params.trade_no}&game_id=${params.game_id}&os=${params.os}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
//通过officialsettingid换取其他配置
export function getOtherConfig(params) {
  return httpRequest({
    url: `${base.url2}/v1/pay/official/game_config?official_setting_id=${params.official_setting_id}`,
    method: "get",
  })
}
//牛玩订单号查询
export function getNwOrderStatus(params) {
  return httpRequest({
    url: `${base.url2}/v1/niuwan/get_order?order_number=${params.order_number}`,
    method: "get",
  })
}
// 牛玩用事件保存
export function saveNwEvent(params) {
  return httpRequest({
    url: `${base.url2}/v1/niuwan/event`,
    method: "post",
    data: qs.stringify(params),
  })
}
//牛玩信息转移
export function transferNwInfo(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/niuwan/save`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 锦鲤活动详情
export function getYearLotteryDetail(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/year_lottery_show?game_id=${params.game_id}&role_id=${params.role_id}&official_setting_id=${params.official_setting_id}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    hideErrorToast: !params.role_id,
  })
}
// 锦鲤抽奖
export function yearLottery(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/wish`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
  })
}
// 锦鲤活动中奖状态查询请求
export function getYearLotteryIsDrawed(params) {
  const store = getStore()
  return httpRequest({
    url: `${base.url2}/v1/pay/official/select_draw?id=${params.id}&role_id=${params.role_id}&round=${params.round}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${store.access_token}`,
    },
    hideErrorToast: !params.role_id,
  })
}
